import cx from 'clsx';
import type { CSSProperties, ReactElement, ReactNode } from 'react';
import { Box } from '@ff-it/ui';
import { row, cell, acell, rcell, invoicesCell, ccell, lcell, supplierCell } from './style.css';

type RowContainerProps = {
  testId?: string;
  className?: string;
  style?: CSSProperties;
  visibleKeys?: Set<string>;
  rowLink?: ReactNode;
  client?: ReactNode;
  supplier?: ReactNode;
  // product?: ReactNode;
  // provider?: ReactNode;
  block?: ReactNode;
  // source
  invoices?: ReactNode;
  source?: ReactNode;
  rate?: ReactNode;
  invoiceable?: ReactNode;
  invoiced?: ReactNode;
  balance?: ReactNode;
  balanceControl?: ReactNode;
  linked?: ReactNode;
  linkedControl?: ReactNode;
  manualControl?: ReactNode;
};

export function RowContainer({
  testId,
  className,
  style,
  visibleKeys,
  rowLink,
  client,
  supplier,
  block,
  invoices,
  source,
  rate,
  invoiceable,
  invoiced,
  balance,
  balanceControl,
  linked,
  linkedControl,
  manualControl,
}: RowContainerProps): ReactElement {
  const show = (key: string): boolean => !visibleKeys || visibleKeys.has(key);
  return (
    <Box className={cx(row, className)} style={style} data-testid={testId}>
      <Box className={lcell} textAlign="center">
        {rowLink}
      </Box>
      {show('client') && <Box className={cell}>{client}</Box>}
      {show('supplier') && <Box className={supplierCell}>{supplier}</Box>}
      {show('block') && <Box className={cell}>{block}</Box>}
      {show('invoices') && <Box className={invoicesCell}>{invoices}</Box>}
      {show('source') && <Box className={acell}>{source}</Box>}
      {show('rate') && <Box className={rcell}>{rate}</Box>}
      {show('invoiceable') && <Box className={acell}>{invoiceable}</Box>}
      {show('invoiced') && <Box className={acell}>{invoiced}</Box>}
      <Box className={acell}>{balance}</Box>
      <Box className={ccell}>{balanceControl}</Box>
      <Box className={acell}>{linked}</Box>
      <Box className={ccell}>{linkedControl}</Box>
      <Box className={ccell}>{manualControl}</Box>
    </Box>
  );
}
